import { useQuery } from "@apollo/client";
import Errors from "components/Errors";
import useRetryOn429 from "hooks/useRetryOn429";
import Page from "components/Page";
import Spinner from "components/Spinner";
import Status from "components/Status";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import { FETCH_PO } from "./graphql";
import PurchaseOrderDeliveriesView from "./PurchaseOrderDeliveriesView";

const PurchaseOrderPage = () => {
  const { odooCompanyId, id } = useParams();
  const { loading, error, data, refetch } = useQuery(FETCH_PO, {
    variables: { odooCompanyId, id },
    fetchPolicy: "network-only",
  });
  const { isAutoRetrying } = useRetryOn429({ error, refetch });

  if (loading || isAutoRetrying) return <Spinner />;
  if (error) return <Errors error={error} />;

  const po = JSON.parse(data.supplierPo);

  const totalOrderQty = po.order_line.reduce(
    (sum, line) => sum + line.product_qty,
    0,
  );
  const totalReceivedQty = po.order_line.reduce(
    (sum, line) => sum + line.qty_received,
    0,
  );
  const totalPendingQty = totalOrderQty - totalReceivedQty;

  return (
    <Page
      title={po.name}
      backTo="/purchase"
      topbarRightView={
        <div className="flex space-x-4">
          {po.state === "draft" && <Status status="订单未确认" />}
          {po.receipt_status === "partial" && <Status status="部分交付" />}
          {po.receipt_status === "full" && <Status status="已完全交付" />}

          {po.state === "purchase" && <Link to="deliver">交付产品</Link>}
        </div>
      }
    >
      <div className="grid grid-cols-12 gap-8 p-8 text-sm">
        <div className=" col-span-full">
          <div className="card">
            <h5>Products 订单产品</h5>
            <div className="mt-2 -mx-2">
              <table>
                <thead>
                  <tr>
                    <th></th>
                    <th className=" text-right">订单数量</th>
                    <th className=" text-right">已交付</th>
                    <th className=" text-right">待交付</th>
                  </tr>
                </thead>
                <tbody>
                  {po.order_line.map((line) => (
                    <tr
                      key={line.id}
                      className={`border-y border-gray-100
                      ${
                        line.product_qty - line.qty_received > 0
                          ? "text-red-600"
                          : "text-green-600"
                      }
                      `}
                    >
                      <td className="">
                        <div>
                          <div>{line.product_id.display_name}</div>
                          <div>{line.product_id.description_purchase}</div>
                        </div>
                      </td>
                      <td className="text-right">{line.product_qty}</td>
                      <td className="text-right">{line.qty_received}</td>
                      <td className="text-right">
                        {line.product_qty - line.qty_received}
                      </td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr>
                    <td>Total</td>
                    <td className="text-right">{totalOrderQty}</td>
                    <td className="text-right">{totalReceivedQty}</td>
                    <td className=" text-right">{totalPendingQty}</td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>
        </div>

        <div className=" col-span-8 space-y-8">
          <div className="card">
            <PurchaseOrderDeliveriesView
              poId={id}
              odooCompanyId={odooCompanyId}
            />
          </div>
        </div>

        <div className="col-span-4">
          <div className="card">
            {/* <h5>Basic Info</h5>*/}
            <div className="-mx-2 whitespace-nowrap">
              <table>
                <tbody>
                  <tr>
                    <td>交付日期:</td>
                    <td className="w-full">
                      {moment(po.date_planned).format("YYYY-MM-DD")}{" "}
                    </td>
                  </tr>
                  <tr>
                    <td>付款条款:</td>
                    <td className="w-full">
                      {po.payment_term_id.display_name}
                    </td>
                  </tr>
                  <tr>
                    <td>关联订单:</td>
                    <td className="w-full">{po.so.display_name}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default PurchaseOrderPage;
